var exports = {
  "Q": "xf0b3b88a--acb9af--answer_form",
  "h": "xf0b3b88a--acb9af--description",
};

module.exports = exports;
